import $ from "jquery";

var options = {
    stringLimit: 400,
    moreText: 'Mehr...',
    lessText: 'Weniger...'
};

export function load(customOptions) {
    if (typeof options != 'undefined') {
        options = {...options, ...customOptions};
    }
    $('.readmore-toggle').each(function() {
        var switchButton = $(this);
        var wrapper = switchButton.prev();
        var wrapperChildren = wrapper.children();
        var stringLength = 0;
        var splitElement = $();
        wrapperChildren.each(function () {
            stringLength += $(this).html().replace(/(<([^>]+)>)/ig,'').length;
            if (!splitElement.length && stringLength > options.stringLimit) {
                splitElement = $(this);
            }
        });
        if (splitElement.index() === 0) {
            splitElement = splitElement.next();
        }
        if (!splitElement.length || splitElement.index() === 0) {
            switchButton.remove();
            return;
        }
        var hideWrapper = $('<div class="readmore-collapse"></div>').insertAfter(wrapper);
        var nextSplitElement = splitElement.next();
        splitElement.detach().appendTo(hideWrapper);
        while (nextSplitElement.length) {
            var detachElement = nextSplitElement;
            nextSplitElement = detachElement.next();
            detachElement.detach().appendTo(hideWrapper);
        }
        hideWrapper.hide();
    }).on('click', function (e) {
        e.preventDefault();
        var switchButton = $(this);
        var wrapper = switchButton.prev();
        if (wrapper.css('display') == 'none') {
            wrapper.slideDown();
            switchButton.html(options.lessText);
        } else {
            switchButton.html(options.moreText);
            wrapper.slideUp();
        }
    });
};
